export default __webpack_public_path__ + "static/poster-62648ae011f7c917f7f68c6d3c323cd2.png";